module.exports = __webpack_public_path__ + "img/img_pop@2x.2fed6e30.png";